import _slicedToArray from "/var/jenkins_home/workspace/tingle.d9ee5bc0-b23f-422f-8a79-1ce42d1d369b/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/var/jenkins_home/workspace/tingle.d9ee5bc0-b23f-422f-8a79-1ce42d1d369b/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.d9ee5bc0-b23f-422f-8a79-1ce42d1d369b/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/var/jenkins_home/workspace/tingle.d9ee5bc0-b23f-422f-8a79-1ce42d1d369b/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/var/jenkins_home/workspace/tingle.d9ee5bc0-b23f-422f-8a79-1ce42d1d369b/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins_home/workspace/tingle.d9ee5bc0-b23f-422f-8a79-1ce42d1d369b/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins_home/workspace/tingle.d9ee5bc0-b23f-422f-8a79-1ce42d1d369b/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// ignore-string-externalization
import React from 'react';
import { marked } from 'marked';
import { renderToString } from 'react-dom/server';
import { UnstyledLink as Link } from '../ui';
import { Type, Table, TableHeaderCell, TableRow, TableCell } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledTableCell = styled(TableCell).withConfig({
  displayName: "DefaultRenderer__StyledTableCell",
  componentId: "sc-18u0kq0-0"
})(["text-align:start;"]);
export var DefaultRenderer = /*#__PURE__*/function (_marked$Renderer) {
  _inherits(DefaultRenderer, _marked$Renderer);

  var _super = _createSuper(DefaultRenderer);

  function DefaultRenderer() {
    _classCallCheck(this, DefaultRenderer);

    return _super.apply(this, arguments);
  }

  _createClass(DefaultRenderer, [{
    key: "link",
    value: function link() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return renderLink.apply(this, args);
    }
  }, {
    key: "paragraph",
    value: function paragraph(text) {
      var str = spotifyWidgetParagraph(text);
      return _get(_getPrototypeOf(DefaultRenderer.prototype), "paragraph", this)(str);
    }
  }, {
    key: "heading",
    value: function heading(text, level) {
      var variant = "heading".concat(level);
      var typeAs = "h".concat(level);
      return renderToString( /*#__PURE__*/_jsx(Type, {
        as: typeAs,
        variant: variant,
        dangerouslySetInnerHTML: {
          __html: text
        }
      }));
    }
  }, {
    key: "hr",
    value: function hr() {
      return '';
    }
  }, {
    key: "table",
    value: function table(header, body) {
      return renderTable(header, body);
    }
  }]);

  return DefaultRenderer;
}(marked.Renderer);
/**
 * Renders a link, external by default
 *
 * @example: [Spotify for Artists](https://artists.spotify.com/ "internal")
 */

export var renderLink = function renderLink(href, title, text) {
  return renderToString( /*#__PURE__*/_jsx(Link, {
    external: title !== 'internal',
    track: ['External Link', "Content Link - ".concat(href)],
    href: href,
    children: /*#__PURE__*/_jsx("span", {
      dangerouslySetInnerHTML: {
        __html: text || title
      }
    })
  }));
};
export var spotifyWidgetParagraph = function spotifyWidgetParagraph(text) {
  if (text.indexOf('[play-button') === 0) {
    var _ref = /\[play-button\s+(spotify:[\w:]+)(?:\s+(compact))?\]/g.exec(text),
        _ref2 = _slicedToArray(_ref, 3),
        uri = _ref2[1],
        compact = _ref2[2];

    var height = compact === 'compact' ? 80 : 380;
    return "<iframe\n      src=\"https://open.spotify.com/embed?uri=".concat(uri, "\"\n      width=\"300\"\n      height=\"").concat(height, "\"\n      frameborder=\"0\"\n      allowtransparency=\"true\"\n      allow=\"encrypted-media\">\n    </iframe>");
  }

  return text;
}; // render simple markdown-produced table as encore table

function renderTable(header, body) {
  var headerCells = header.split(/<th>(.*)<\/th>/).map(function (val) {
    return val === null || val === void 0 ? void 0 : val.replace(/<[/]?t[rh]{1}>/, '').trim();
  }).filter(Boolean).map(function (val, i) {
    return /*#__PURE__*/_jsx(TableHeaderCell, {
      dangerouslySetInnerHTML: {
        __html: val
      }
    }, "th-".concat(i));
  });
  var bodyRows = body.split(/<tr>/).map(function (val) {
    return val === null || val === void 0 ? void 0 : val.replace('</tr>', '').trim();
  }).filter(Boolean).map(function (val, i) {
    var cells = val.split(/<td>(.*)<\/td>/).map(function (cellVal) {
      return cellVal === null || cellVal === void 0 ? void 0 : cellVal.trim();
    }).filter(Boolean).map(function (cellVal, j) {
      return /*#__PURE__*/_jsx(StyledTableCell, {
        dangerouslySetInnerHTML: {
          __html: cellVal
        }
      }, "td-".concat(i, "-").concat(j));
    });
    return /*#__PURE__*/_jsx(TableRow, {
      children: cells
    }, "tr-".concat(i));
  });

  var output = /*#__PURE__*/_jsxs(Table, {
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsx(TableRow, {
        children: headerCells
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: bodyRows
    })]
  });

  return renderToString(output);
}